<template>
  <div class="curriculum el-col-24">
    <div class="tableTitle">
      <i class="icon icon-shu"></i>将课中资源匹配至你的备课中
      <!--      <img @click="goDetail" src="@/assets/images/shaohou.png" alt="" class="shaohou">-->
    </div>
    <table class="table el-col-23" border="1">
      <thead class="thead">
        <td>资源名称</td>
        <td>查看资源</td>
        <td>删除资源</td>
        <td>课程匹配</td>
      </thead>
      <tr v-for="(item, index) in storeroom.list" :key="index">
        <td @click="goMyDetail(item.PlanClassID, item.lessonID)">
          {{ item.ClassName }}_{{ item.CreateDateStr }}
        </td>
        <td
          style="color: #1e87f0"
          @click="goMyDetail(item.PlanClassID, item.lessonID)"
        >
          查看
        </td>

        <td
          @click="deleteClass(item.PlanClassID, item.lessonID)"
          style="color: #1e87f0"
        >
          删除
        </td>
        <td @click="ppClassList(item.PlanClassID)" style="color: #1e87f0">
          点击匹配
        </td>
      </tr>
    </table>

    <!--        分页-->
    <div v-if="storeroom.total >= 6" class="block el-col-24">
      <el-pagination
        @current-change="storeroomChange"
        :current-page.sync="storeroom.page"
        :page-size="storeroom.limit"
        layout="prev, pager, next, jumper"
        :total="storeroom.total"
      >
      </el-pagination>
    </div>
    <!--      匹配课程-->
    <el-dialog
      class="tk_pp"
      title="匹配课程"
      :visible.sync="ppkc"
      width="50%"
      overflow="hidden"
      center
    >
      <div class="tk_top">课程名称 <span>备课时间</span></div>
      <div style="height: 50vh; overflow-y: scroll">
        <div v-for="item in radioArr" class="radioBox" :key="item.CourseID">
          <el-radio v-model="radio" :label="item.TeachingPlanID">{{
            item.CourseTitle
          }}</el-radio>
          <div class="el-time">{{ item.CreateDate }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ppkc = false">取 消</el-button>
        <el-button type="primary" @click="ppClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ResourceList",
  data() {
    return {
      storeroom: {
        //列表分页
        list: [],
        page: 1,
        limit: 10,
        total: 30,
      },
      radioArr: [], //匹配列表
      ppkc: false, //匹配课程弹框
      radio: 1, //匹配课程的id
    };
  },
  mounted() {
    this.getMyList();
  },
  watch: {
    $route(to, from) {
      if (to.name == "ResourceList") {
        if (from.name != "ResourceDetail") {
          this.storeroom.page = 1;
        }
        this.getMyList();
      }
    },
  },
  methods: {
    goDetail() {
      let that = this;
      let id = localStorage.getItem("ChapterID");
      let name = localStorage.getItem("name");
      if (id != null) {
        this.$router.push({
          name: "Detail",
          query: { id: id, name: name, css: "1" },
        });
      } else {
        let timer = setTimeout(function () {
          let arr = that.store.state.menu;
          if (arr.length != 0) {
            that.$router.push({
              name: "Detail",
              query: { id: arr[0].id, name: arr[0].name, css: "1" },
            });
          }
          clearTimeout(timer);
        }, 500);
      }
    },
    getMyList() {
      if (localStorage["token"]) {
        let that = this;
        this.axios
          .post(window.url + "GetTeachingPlanClass", {
            currentPage: that.storeroom.page,
          })
          .then((res) => {
            var data = res.data;
            that.returnCode(data.result, data.message);
            if (data.data.Content.length == 0) {
              that.store.state.index = false;
              that.goDetail();
            }
            that.storeroom.list = data.data.Content;
            if (that.storeroom.list.length != 0) {
              that.store.state.index = true;
            }
            that.storeroom.limit = data.data.pageSize;
            that.storeroom.total = data.data.totalSize;
          })
          .catch((error) => {
            // that.$message.error('您的网络开小差了！')
          });
      }
    },
    // 分页start
    storeroomChange(e) {
      let that = this;
      that.storeroom.page = e;
      that.getMyList();
    },
    // 分页end
    // 匹配列表
    ppClassList(PlanClassID) {
      let that = this;
      that.PlanClassID = PlanClassID;
      this.axios
        .post(window.url + "MatchingPlan", {
          PlanClassID: PlanClassID,
        })
        .then((res) => {
          var data = res.data;
          that.returnCode(data.result, data.message);
          that.ppkc = true;
          that.radioArr = data.data;
        })
        .catch((error) => {
          // that.$message.error('您的网络开小差了！')
        });
    },

    //删除上课资源
    deleteClass(planClassID, lessonID) {
      this.$confirm("确认删除该上课资源吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "DeleteUnmatchedClass", {
              planClassId: planClassID,
              lessonId: lessonID,
            })
            .then((res) => {
              var data = res.data;
              if (data.result == 200) {
                this.$message.success("删除成功！");
                this.getMyList();
              }
            })
            .catch((error) => {
              // that.$message.error('您的网络开小差了！')
            });
        })
        .catch(() => {});
    },

    // 匹配课程
    ppClick() {
      var that = this;
      that.ppkc = false;
      this.axios
        .post(window.url + "Matching", {
          PlanClassID: that.PlanClassID,
          TeachingPlanID: that.radio,
        })
        .then((res) => {
          var data = res.data;
          that.returnCode(data.result, data.message);
          that.PlanClassID = "";
          that.radio = 1;
          that.getMyList();
        })
        .catch((error) => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    goMyDetail(id, lessonID) {
      this.$router.push({
        name: "ResourceDetail",
        query: { id: id, lessonID: lessonID },
      });
    },
    // 返回值调用
    returnCode(code, msg) {
      var that = this;
      if (code != 200) {
        if (code == 201) {
          this.$router.push({ name: "Login" });
        }
        that.$message.error(msg);
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.curriculum {
  /*min-height: 960px;*/

  .tableTitle {
    height: 70px;
    line-height: 70px;
    font-size: 22px;
    text-align: left;

    .icon-shu {
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 18px;
      margin: 0px 10px;
      display: inline-block;
    }

    .shaohou {
      height: 36px;
      margin-left: 30px;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .table {
    border: 1px solid #e3e5e7;
    margin: 0 auto;

    .pipeiImg {
      display: block;
      width: 100px;
      height: 34px;
      margin: 10px auto;
    }

    .thead {
      background-color: #f6f6f6;

      td {
        text-align: center;
      }
    }

    tr {
      cursor: pointer;

      td:nth-child(1) {
        text-align: left;
        text-indent: 2em;
      }
    }

    td {
      height: 44px;
      line-height: 44px;
    }
  }

  .block {
    margin-top: 20px;
  }

  .addClass {
    background-color: #149bd7ff;
    float: left;
    margin: 30px;
    padding: 6px 30px;
    color: #ffffff;
    cursor: pointer;
    font-size: 16px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }

  .tk_top {
    height: 40px;
    line-height: 40px;
    text-indent: 2em;
    background-color: #eaedf2;

    span {
      width: 40%;
      text-align: left;
      float: right;
    }
  }

  .radioBox {
    border-bottom: 1px solid #dedede;
    padding: 0 2%;
    line-height: 40px;
    height: 40px;
    overflow: hidden;

    .el-radio {
      width: 60%;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-time {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
<style lang="less">
.el-dialog .el-dialog--center .el-dialog__body {
  padding: 0 !important;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.el-radio__inner {
  border-color: #8a8a8a;
}
</style>



// WEBPACK FOOTER //
// src/components/ResourceList.vue